import {
  Container,
  Grid,
  Box,
  makeStyles,
  useTheme,
  Slide,
  Fade,
  Grow,
  Typography,
  Avatar,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import Axios from "axios";
import { Helmet } from "react-helmet-async";
import { Loading } from "../../components/shared/loading";
import { TypingQuote } from "../../components/shared/TypingQuote";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    backgroundImage: 'linear-gradient(rgba(76, 0, 76, 0.85), rgba(76, 0, 76, 0.9)), url("/static/our_team.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    minHeight: "35vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroContent: {
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    textShadow: "0 2px 15px rgba(0,0,0,0.3)",
  },
  heroDivider: {
    width: 40,
    height: 2,
    background: "rgba(255,255,255,0.5)",
    margin: "12px auto",
    borderRadius: 2,
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
  },
  section: {
    padding: "40px 0",
    background: "#fafafa",
  },
  sectionWhite: {
    padding: "40px 0",
    background: "#ffffff",
  },
  sectionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 8,
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#666666",
    textAlign: "center",
    maxWidth: 450,
    margin: "0 auto 28px",
    lineHeight: 1.5,
  },
  // ── LEADERSHIP CARDS (Premium) ──
  "@keyframes shimmerBorder": {
    "0%": { backgroundPosition: "200% center" },
    "100%": { backgroundPosition: "-200% center" },
  },
  "@keyframes pulseGlow": {
    "0%, 100%": { boxShadow: "0 24px 56px rgba(76,0,76,0.18)" },
    "50%": { boxShadow: "0 28px 64px rgba(76,0,76,0.28)" },
  },
  leaderWrap: {
    position: "relative",
    borderRadius: 18,
    padding: 2,
    background: "#4c004c",
    transition: "transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: 18,
      background: "linear-gradient(90deg, transparent 0%, rgba(155,59,155,0.7) 20%, rgba(255,255,255,0.5) 50%, rgba(155,59,155,0.7) 80%, transparent 100%)",
      backgroundSize: "200% auto",
      opacity: 0,
      transition: "opacity 0.4s ease",
      zIndex: 0,
      pointerEvents: "none",
    },
    "&:hover": {
      transform: "translateY(-12px)",
      animation: "$pulseGlow 2s ease-in-out infinite",
    },
    "&:hover::before": {
      opacity: 1,
      animation: "$shimmerBorder 2s linear infinite",
    },
  },
  leaderCard: {
    display: "flex",
    flexDirection: "row",
    borderRadius: 16,
    width: "100%",
    overflow: "hidden",
    position: "relative",
    zIndex: 1,
    background: "#ffffff",
    [theme.breakpoints.down('xs')]: {
      flexDirection: "column",
    },
  },
  leaderImgSide: {
    width: 210,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 28,
    background: "linear-gradient(160deg, #5a0a5a 0%, #4c004c 40%, #3a003a 100%)",
    position: "relative",
    [theme.breakpoints.down('sm')]: {
      width: 170,
      padding: 20,
    },
    [theme.breakpoints.down('xs')]: {
      width: "100%",
      padding: "32px 20px 24px",
    },
  },
  leaderAvatarWrap: {
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      inset: -6,
      borderRadius: "50%",
      border: "1px solid rgba(255,255,255,0.08)",
      transition: "all 0.5s ease",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      inset: -12,
      borderRadius: "50%",
      border: "1px solid rgba(255,255,255,0.04)",
      transition: "all 0.5s ease",
    },
    "$leaderWrap:hover &::before": {
      inset: -8,
      borderColor: "rgba(255,255,255,0.15)",
    },
    "$leaderWrap:hover &::after": {
      inset: -16,
      borderColor: "rgba(255,255,255,0.08)",
    },
  },
  leaderAvatar: {
    width: 140,
    height: 140,
    borderRadius: "50%",
    objectFit: "cover",
    display: "block",
    border: "4px solid rgba(255,255,255,0.18)",
    boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
    background: "#3a003a",
    transition: "border-color 0.5s ease, transform 0.5s ease",
    position: "relative",
    zIndex: 1,
    "$leaderWrap:hover &": {
      borderColor: "rgba(255,255,255,0.35)",
      transform: "scale(1.04)",
    },
    [theme.breakpoints.down('sm')]: {
      width: 115,
      height: 115,
    },
  },
  leaderContent: {
    flex: 1,
    padding: "28px 32px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    background: "#ffffff",
    [theme.breakpoints.down('sm')]: {
      padding: "22px 24px",
    },
    [theme.breakpoints.down('xs')]: {
      alignItems: "center",
      textAlign: "center",
      padding: "18px 24px 28px",
    },
  },
  leaderName: {
    fontSize: "1.05rem",
    fontWeight: 700,
    color: "#1a1a1a",
    marginBottom: 4,
    letterSpacing: "0.2px",
  },
  leaderDesig: {
    fontSize: "0.62rem",
    color: "#4c004c",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "1.8px",
    marginBottom: 14,
  },
  leaderAccent: {
    width: 30,
    height: 2,
    background: "linear-gradient(90deg, #4c004c, #9b3b9b)",
    borderRadius: 2,
    marginBottom: 14,
    transition: "width 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    "$leaderWrap:hover &": {
      width: 55,
    },
    [theme.breakpoints.down('xs')]: {
      margin: "0 auto 14px",
    },
  },
  leaderDesc: {
    fontSize: "0.76rem",
    color: "#555",
    lineHeight: 1.75,
    [theme.breakpoints.down('sm')]: {
      fontSize: "0.72rem",
    },
  },

  // ── CORE DEVELOPER CARDS (Clean) ──
  "@keyframes glowRing": {
    "0%, 100%": { boxShadow: "0 0 0 0 rgba(76,0,76,0)" },
    "50%": { boxShadow: "0 0 0 6px rgba(76,0,76,0.12)" },
  },
  devCard: {
    borderRadius: 16,
    width: "100%",
    background: "#ffffff",
    overflow: "hidden",
    boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
    border: "1px solid rgba(0,0,0,0.05)",
    transition: "all 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
      width: 0,
      height: 3,
      background: "linear-gradient(90deg, #4c004c, #9b3b9b, #4c004c)",
      transition: "width 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    },
    "&:hover": {
      transform: "translateY(-10px)",
      boxShadow: "0 20px 48px rgba(76,0,76,0.14)",
      borderColor: "rgba(76,0,76,0.06)",
    },
    "&:hover::after": {
      width: "100%",
    },
    "&:hover $devAvatarRing": {
      animation: "$glowRing 1.5s ease-in-out infinite",
    },
    "&:hover $devAvatar": {
      borderColor: "rgba(255,255,255,0.5)",
      transform: "scale(1.05)",
    },
  },
  devImgBand: {
    background: "linear-gradient(160deg, #5a0a5a 0%, #4c004c 50%, #3a003a 100%)",
    padding: "32px 20px 36px",
    display: "flex",
    justifyContent: "center",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: -18,
      left: "50%",
      transform: "translateX(-50%)",
      width: 0,
      height: 0,
      borderLeft: "20px solid transparent",
      borderRight: "20px solid transparent",
      borderTop: "18px solid #3a003a",
    },
  },
  devAvatarRing: {
    borderRadius: "50%",
    padding: 0,
    display: "inline-flex",
    transition: "all 0.4s ease",
  },
  devAvatar: {
    width: 120,
    height: 120,
    borderRadius: "50%",
    objectFit: "cover",
    display: "block",
    border: "4px solid rgba(255,255,255,0.2)",
    boxShadow: "0 6px 24px rgba(0,0,0,0.25)",
    background: "#3a003a",
    transition: "all 0.4s ease",
    [theme.breakpoints.down('sm')]: {
      width: 104,
      height: 104,
    },
  },
  devBody: {
    padding: "26px 22px 24px",
    textAlign: "center",
    [theme.breakpoints.down('sm')]: {
      padding: "24px 18px 20px",
    },
  },
  devName: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#1a1a1a",
    marginBottom: 3,
    letterSpacing: "0.15px",
  },
  devDesig: {
    fontSize: "0.6rem",
    color: "#4c004c",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "1.2px",
    marginBottom: 12,
    opacity: 0.75,
  },
  devAccent: {
    width: 20,
    height: 2,
    background: "linear-gradient(90deg, #6b1b6b, #9b3b9b)",
    borderRadius: 2,
    margin: "0 auto 12px",
  },
  devDesc: {
    fontSize: "0.73rem",
    color: "#666",
    lineHeight: 1.7,
    [theme.breakpoints.down('sm')]: {
      fontSize: "0.7rem",
    },
  },
  quoteSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "12px",
    padding: "28px 24px",
    marginTop: 32,
    textAlign: "center",
  },
  quoteText: {
    fontSize: "0.9rem",
    color: "#ffffff",
    lineHeight: 1.6,
    fontStyle: "italic",
    maxWidth: 700,
    margin: "0 auto 12px",
  },
  quoteAuthor: {
    color: "#ffffff",
    fontSize: "0.8rem",
    fontWeight: 600,
    opacity: 0.9,
  },
}));
  
  export const OurTeam = () => {
    const theme = useTheme();
  
    const classes = useStyles();
    const [team1, setTeam1] = useState([]);
    const [team2, setTeam2] = useState([]);
    const [metaTitle, setMetaTitle] = useState("");
    const [metaDesc, setMetaDesc] = useState("");
    const [metaKeywords, setMetaKeywords] = useState("");
    const [isloading, setIsloading] = useState(true);
  
    const handleClick = () => {
      const anchor = document.querySelector("#back-to-top-anchor");
  
      if (anchor) {
        anchor.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };
  
    useEffect(() => {
      getMetaData();
    }, []);
  
    const getMetaData = async () => {
      const formData = new FormData();
      formData.append("page", 8);
      await Axios.post("/api/getmetadata", formData, {
        headers: { headKey: headKey },
      }).then((res) => {
        if (res.data.status) {
          setMetaTitle(res.data.data.meta_title);
          setMetaKeywords(res.data.data.meta_keywords);
          setMetaDesc(res.data.data.meta_desc);
          
          
        }
      });
      await  Axios.post("/api/get_all_team", {
        headers: { headKey: headKey },
      }).then((res) => {
        
        if (res.data.status) {
          setTeam1(res.data.team1);
          setTeam2(res.data.team2);
          setIsloading(false);
          handleClick();
          // console.log(res.data.status);
          // setData(ReactHtmlParser(res.data.data.description));
        }
      });
    };
  
      
    return (
      <div>
        <Helmet>
          <title>{metaTitle}</title>
          <meta name="description" content={metaDesc} />
          <meta name="keywords" content={metaKeywords}></meta>
        </Helmet>
        {/* Hero Section */}
        <Box className={classes.heroSection}>
          <Fade in={true} timeout={1000}>
            <Box className={classes.heroContent}>
              <Typography className={classes.heroTitle}>
                Our Team
              </Typography>
              <Box className={classes.heroDivider} />
              <Typography className={classes.heroSubtitle}>
                The Brains Behind Our Breakthroughs
              </Typography>
            </Box>
          </Fade>
        </Box>

        {isloading ? (
          <Loading />
        ) : (
          <>
          {/* Leadership Team Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Leadership Team
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Get to know our leaders, their expertise, and the vision that guides us
                  </Typography>
                </Box>
              </Slide>

              <Grid container spacing={3}>
                {team1.map((team, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Grow in={true} timeout={800 + index * 150}>
                      <Box className={classes.leaderWrap}>
                        <Box className={classes.leaderCard}>
                          <Box className={classes.leaderImgSide}>
                            <Box className={classes.leaderAvatarWrap}>
                              <img
                                src={"/static/team/" + team.image}
                                alt={team.name}
                                className={classes.leaderAvatar}
                              />
                            </Box>
                          </Box>
                          <Box className={classes.leaderContent}>
                            <Typography className={classes.leaderName}>
                              {team.name}
                            </Typography>
                            <Typography className={classes.leaderDesig}>
                              {team.designation}
                            </Typography>
                            <Box className={classes.leaderAccent} />
                            <Typography className={classes.leaderDesc}>
                              {team.description}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grow>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Box>

          {/* Core Developers Section */}
          <Box className={classes.sectionWhite}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Core Developers
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Discover the talented developers behind our cutting-edge solutions
                  </Typography>
                </Box>
              </Slide>

              <Grid container spacing={3}>
                {team2.map((team, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Grow in={true} timeout={800 + index * 150}>
                      <Box className={classes.devCard}>
                        <Box className={classes.devImgBand}>
                          <Box className={classes.devAvatarRing}>
                            <img
                              src={"/static/team/" + team.image}
                              alt={team.name}
                              className={classes.devAvatar}
                            />
                          </Box>
                        </Box>
                        <Box className={classes.devBody}>
                          <Typography className={classes.devName}>
                            {team.name}
                          </Typography>
                          <Typography className={classes.devDesig}>
                            {team.designation}
                          </Typography>
                          <Box className={classes.devAccent} />
                          <Typography className={classes.devDesc}>
                            {team.description}
                          </Typography>
                        </Box>
                      </Box>
                    </Grow>
                  </Grid>
                ))}
              </Grid>

              {/* Quote Section */}
              <Fade in={true} timeout={1400}>
                <Box className={classes.quoteSection}>
                  <TypingQuote
                    text={`"At Arawinz, our ethos is rooted in the seamless fusion of creativity and commitment, driving us to provide outstanding results. Our path is defined by an unwavering dedication to surpassing expectations and an earnest endeavor to grasp and cater to our clients' unique requirements. As a collective, we transcend mere collaboration – we are visionaries shaping tomorrow, piecing together a more intelligent and interconnected reality."`}
                    className={classes.quoteText}
                  />
                  <Typography className={classes.quoteAuthor}>
                    — Dr. P. Srinivas Rao, CEO
                  </Typography>
                </Box>
              </Fade>
            </Container>
          </Box>
        </>
        )}
     
      </div>
    );
  };
  

